// extracted by mini-css-extract-plugin
export default {"testimony":"styles_testimony__87QL8","overlay":"styles_overlay__r26JC","icon":"styles_icon__7-7Uv"};